import { AlbumPage } from './../album/album';
import { album } from './../../models/album.model';
import { AlbumService } from './../../service/album.service';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content } from 'ionic-angular';

@Component({
  selector: 'page-find',
  templateUrl: 'find.html'
})
export class FindPage {

  @ViewChild(Content) content: Content;

  myInput:string;

  constructor(public navCtrl: NavController, private navPar:NavParams,
    public albumService: AlbumService) {
  }

  ionViewDidEnter() {


    if (this.navPar.get("cat") != "")
    {
      let element = document.getElementById(this.navPar.get("cat"));
      
      if (element)
      {
        let yOffset = element.offsetTop;
        this.content.scrollTo(0, yOffset, 1000)
       //   element.scrollIntoView();
      }
    }
  }


  open(item:album)
  {
    this.navCtrl.push(AlbumPage, {item: item});
  }

}



// WEBPACK FOOTER //
// ./src/pages/find/find.ts